import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=5d6189c0&"
import script from "./ChatHeader.vue?vue&type=script&lang=ts&"
export * from "./ChatHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=5d6189c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports